module.exports = __webpack_public_path__ + "img/Clear.4aa4100d.svg";